var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8986 7.07059C12.1029 5.75448 10.2606 4.13238 8.94931 2.16549L7.80141 0.443711C7.55823 0.0789416 7.10494 -0.0834881 6.68372 0.0429494C6.2635 0.170383 5.97656 0.557531 5.97656 0.996278V16.6246C5.3882 16.2815 4.71332 16.0705 3.98438 16.0705C1.78693 16.0705 0 17.8574 0 20.0549C0 22.2523 1.78693 24.0392 3.98438 24.0392C6.18182 24.0392 7.96875 22.2523 7.96875 20.0548V4.26685C9.3763 6.04601 11.137 7.51611 12.7206 8.67756C13.4988 9.24759 13.9453 10.127 13.9453 11.09C13.9453 12.7378 12.6048 14.0782 10.957 14.0782C10.4065 14.0782 9.96094 14.5238 9.96094 15.0743C9.96094 15.6249 10.4065 16.0704 10.957 16.0704C13.7031 16.0704 15.9375 13.8361 15.9375 11.09C15.9375 9.50923 15.1758 8.00732 13.8986 7.07059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7306 8.13943L18.6525 12.1238C18.2245 12.2464 17.9297 12.6374 17.9297 13.082V26.5853C17.3413 26.2422 16.6664 26.0312 15.9375 26.0312C13.7401 26.0312 11.9531 27.8181 11.9531 30.0156C11.9531 32.213 13.7401 33.9999 15.9375 33.9999C18.1349 33.9999 19.9219 32.213 19.9219 30.0156C19.9219 29.7885 19.9219 17.8181 19.9219 17.8181L32.0078 14.4029V22.6009C31.4195 22.2578 30.7446 22.0468 30.0156 22.0468C27.8182 22.0468 26.0312 23.8337 26.0312 26.0312C26.0312 28.2286 27.8182 30.0156 30.0156 30.0156C32.2131 30.0156 34 28.2286 34 26.0312C34 25.8041 34 9.0976 34 9.0976C34 8.43879 33.3698 7.95887 32.7306 8.13943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.b6695b516f4fee5437afd85b1681754f.svg";
export { ForwardRef as ReactComponent };